import { useQuery } from '@tanstack/react-query';
import { useSimpleSectors } from './useSimpleSectors';
import { AboutSectorsData } from '@/types/aboutSectors';
import { useGlobalSetting } from '@/hooks/useGlobalSettings';
import { resolveMediaUrl } from '@/utils/media';

// Content defaults - يُستبدل لاحقاً بنصوص العميل الحرفية
const DEFAULT_ABOUT_DATA = {
  label_ar: "من نحن",
  label_en: "About Us",
  headline_ar: "ثمانية عقود من الريادة والابتكار",
  headline_en: "Eight Decades of Leadership and Innovation",
  cta_text_ar: "اكتشف قصتنا",
  cta_text_en: "Discover Our Story",
  cta_href: "/about",
  years: 80,
  blurb_ar: "مجموعة أباسك، رائدة في قطاعات متعددة منذ عام 1945، تواصل رحلتها في بناء مستقبل مستدام وتحقيق التميز في جميع استثماراتها.",
  blurb_en: "ABASC HOLDING, a multi-sector leader since 1945, continues its journey in building a sustainable future and achieving excellence across all its investments."
};

export const useAboutSectorsData = (): { data: AboutSectorsData; isLoading: boolean; error: unknown } => {
  const { data: sectorsData, isLoading: sectorsLoading, error: sectorsError } = useSimpleSectors();
  // Global fallbacks
  const defaultCard = useGlobalSetting<string>('appearance.default_card_image_url', undefined);
  const defaultIcon = useGlobalSetting<string>('appearance.default_icon_url', undefined);
  
  // Helper to ensure excerpt is short and single-line friendly
  const toExcerpt = (input?: string, maxLen = 160) => {
    if (!input) return '';
    const text = String(input).replace(/\s+/g, ' ').trim();
    if (text.length <= maxLen) return text;
    return text.slice(0, maxLen - 1).trimEnd() + '…';
  };

  const transformedData: AboutSectorsData = {
    about: DEFAULT_ABOUT_DATA,
    sectors: sectorsData?.map(sector => {
      const featured = sector.featured_image_url;
      const image = resolveMediaUrl(featured) 
        || (defaultCard ? resolveMediaUrl(defaultCard) : undefined)
        || '/placeholder.svg';
      const icon = resolveMediaUrl(sector.icon_url)
        || (defaultIcon ? resolveMediaUrl(defaultIcon) : undefined);
      return {
        slug: sector.slug,
        name_ar: sector.name_ar,
        name_en: sector.name_en,
        image,
        // Excerpt must only come from short_description fields; never fall back to long description
        excerpt_ar: toExcerpt(sector.short_description_ar) || '',
        excerpt_en: toExcerpt(sector.short_description_en) || '',
        icon_url: icon,
      };
    }) || []
  };

  return {
    data: transformedData,
    isLoading: sectorsLoading,
    error: sectorsError
  };
};